"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getProperty(props, id) {
    if (props && props[id]) {
        return props[id].values.map(function (v) { return v.text; }).join(', ');
    }
    else {
        return undefined;
    }
}
exports.getProperty = getProperty;
